//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import React from 'react';

import Icon from '@components/atoms/icon/Icon';
import Indicator from '@components/atoms/indicator/Indicator';
import TimezoneIndicator from '@components/atoms/timezone-indicator/TimezoneIndicator';
import CopyrightedImagePlaceholder from '@components/molecules/copyrighted-image-placeholder/CopyrightedImagePlaceholder';
import StatBubble from '@components/molecules/stat-bubble/StatBubble';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';

/**
 * A universal holding place for bridged Angular versions of atomic design components.
 * These live here rather than in the component files so we can keep Angular out of Storybook.
 */

/** Atoms */

angular.module('curalate').component('indicator', {
  bindings: {
    showIf: '<',
    title: '<',
    offset: '<',
  },
  controller: makeAngularReactControllerWithScope(
    ({ $ctrl }: { $ctrl: React.ComponentProps<typeof Indicator> }) => {
      return (
        <Indicator
          showIf={$ctrl.showIf}
          title={$ctrl.title}
          offset={$ctrl.offset}
        />
      );
    },
  ),
});

angular.module('curalate').component('unisonCoreIcon', {
  bindings: {
    name: '@',
  },
  controller: makeAngularReactControllerWithScope(
    ({ $ctrl }: { $ctrl: React.ComponentProps<typeof Icon> }) => (
      <Icon name={$ctrl.name} />
    ),
  ),
});

angular.module('curalate').component('timezoneIndicator', {
  bindings: {
    isTimestampIndicator: '<',
    timeZone: '@',
  },
  controller: makeAngularReactControllerWithScope(
    ({ $ctrl }: { $ctrl: React.ComponentProps<typeof TimezoneIndicator> }) => (
      <TimezoneIndicator
        isTimestampIndicator={$ctrl.isTimestampIndicator}
        timeZone={$ctrl.timeZone}
      />
    ),
  ),
});

/** Molecules */

angular.module('curalate').component('statBubbleMolecule', {
  bindings: {
    title: '<?',
    helpText: '<?',
    alertText: '<?',
    value: '<?',
  },
  controller: makeAngularReactControllerWithScope(
    ({ $ctrl }: { $ctrl: React.ComponentProps<typeof StatBubble> }) => (
      <StatBubble
        title={$ctrl.title}
        helpText={$ctrl.helpText}
        alertText={$ctrl.alertText}
        value={$ctrl.value}
      />
    ),
  ),
});

angular.module('curalate').component('copyrightedImagePlaceholder', {
  bindings: {
    placeholderType: '<',
    size: '<',
    copyrightMessage: '<?',
  },
  controller: makeAngularReactControllerWithScope(
    ({
      $ctrl,
    }: {
      $ctrl: React.ComponentProps<typeof CopyrightedImagePlaceholder>;
    }) => (
      <CopyrightedImagePlaceholder
        placeholderType={$ctrl.placeholderType}
        size={$ctrl.size}
        copyrightMessage={$ctrl.copyrightMessage}
      />
    ),
  ),
});
